var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.3 500",
    style: {
      enableBackground: "new 0 0 471.3 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#103DAF;}\n\t.st1{fill:#5895FF;}\n\t.st2{fill:#FFFFFF;fill-opacity:0.4;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#1E49D3;enable-background:new    ;}\n\t.st5{fill:#043017;}\n\t.st6{fill:#157241;}\n\t.st7{fill:#34935F;}\n\t.st8{fill:#07542A;}\n\t.st9{fill:#BC3228;}\n\t.st10{fill:#F45B42;}\n\t.st11{fill:#CC493B;}\n\t.st12{fill:#F98073;}\n\t.st13{fill:#073551;}\n\t.st14{fill:#48A8FF;}\n\t.st15{fill:#2477B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "0,268.5 80.7,230.3 80.7,268.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "471.3,268.5 390.5,230.3 390.5,268.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M276.4,2l163,166v273.9c0,32.1-25.5,58.1-57,58.1H89c-31.5,0-57-26-57-58.1V60.1C31.9,28,57.5,2,89,2H276.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.4,168H336.3c-31.5,0-59.9-28.9-59.9-61V2L439.4,168z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 268.5,
    className: "st15",
    width: 471.3,
    height: 156.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M209.1,306.5v78.8h-15.8v-51.3l-21.1,51.3h-12L139,334.1v51.3h-15.8v-78.8h18l25.1,58.6l25.1-58.6H209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M279.2,342.8c-2,3.7-5.1,6.7-9.4,8.9c-4.3,2.3-9.6,3.4-16.1,3.4h-13.2v30.3h-15.8v-78.8h29 c6.1,0,11.3,1.1,15.6,3.2c4.3,2.1,7.5,5,9.7,8.7c2.1,3.7,3.2,7.9,3.2,12.5C282.2,335.1,281.2,339.1,279.2,342.8z M262.8,339.3 c2.1-2,3.2-4.8,3.2-8.4c0-7.7-4.3-11.5-12.9-11.5h-12.5v22.9h12.5C257.4,342.3,260.7,341.3,262.8,339.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M290.9,369.3v-12.4l36.9-52.8h18.4v51.5h9.9v13.8h-9.9v16h-15.8v-16H290.9z M331.4,321l-23.1,34.6h23.1V321z "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M181.2,173.1V98H96.8v75.1H181.2z M190.6,112.1L218.7,98v75.1L190.6,159v18.8c0,2.6-2.1,4.7-4.7,4.7H92.1 c-2.6,0-4.7-2.1-4.7-4.7V93.3c0-2.6,2.1-4.7,4.7-4.7h93.8c2.6,0,4.7,2.1,4.7,4.7V112.1z M190.6,122.6v25.9l18.8,9.4v-44.7 L190.6,122.6z M106.2,107.4h28.1v9.4h-28.1V107.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcMp4);
export default __webpack_public_path__ + "static/media/ac_mp4.bc83c40e6c1123e3c434fdccf39cf7de.svg";
export { ForwardRef as ReactComponent };